
import Title from './Title';

export default class TitleCollection extends Backbone.Collection {
    get model() { return Title; }
}

